<div class="container-fluid vh-100" style="background-color:#f8f8f8;">
  <!-- {{ 'example' | translate }} -->
  <div class="div-center d-flex justify-content-center align-items-center">
    <div class="h-100 w-100">
      <div class="d-flex justify-content-center align-items-center h-25 p-2">
        <img src="../../../assets/images/logo_rojo.png" class="img-fluid" alt="Logo">
      </div>

      <div class="h-75 p-2" *ngIf="!error409">
        <form class="h-100">
          <div class="form-row">
            <div class="form-group col-md">
              <input type="email" class="form-control" id="exampleInputEmail1"
                placeholder="{{ 'login.user' | translate }}" [(ngModel)]="user" name="user"
                style="background-color:#f8f8f8">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md">
              <input type="password" class="form-control" id="exampleInputPassword1"
                placeholder="{{ 'login.password' | translate }}" [(ngModel)]="password" name="password"
                style="background-color:#f8f8f8">
            </div>
          </div>
          <div class="form-row align-items-end h-50">
            <div class="col-md text-center">
              <button type="button" class="btn btn-outline-dark btn-lg sharp" style="width: 200px;"
                (click)="sendLogin();">{{ 'login.submit' | translate }}</button>
            </div>
          </div>
        </form>
      </div>

      <div class="h-75 p-2" *ngIf="error409">
        <!--<p id="forceLogin">El usuario informado ya cuenta con una sesión en curso, puedes reenviar la información, a lo que la sesión anterior quedará inválida.</p>
      -->
        <ngb-alert type="warning" class="text-center" style="
            position: fixed;
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9999;
            max-width: 600px;
            width: 90%;
          ">

          <div>
            El usuario informado ya cuenta con una sesión en curso.
          </div>
          <div class="mt-1">
            Puedes reenviar la información y la sesión anterior quedará inválida.
          </div>

        </ngb-alert>
        <form class="h-100">
          <div class="form-row">
            <div class="form-group col-md">
              <input type="email" class="form-control" id="exampleInputEmail1"
                placeholder="{{ 'login.user' | translate }}" [(ngModel)]="user" name="user"
                style="background-color:#f8f8f8">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md">
              <input type="password" class="form-control" id="exampleInputPassword1"
                placeholder="{{ 'login.password' | translate }}" [(ngModel)]="password" name="password"
                style="background-color:#f8f8f8">
            </div>
          </div>
          <div class="form-row align-items-end h-50">
            <div class="col-md text-center">
              <button type="button" class="btn btn-outline-dark btn-lg sharp" style="width: 200px;"
                (click)="sendForcedLogin();">{{ 'login.submit' | translate }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>